import React from "react";
import { FiUser } from "react-icons/fi";
import CircleIcon from "./CircleIcon";
import { formatDate, getBirthDateValue, getChildAge, getChildName } from "../utils/childUtils";
import { getClassroomLabel, getClassroomName } from "../utils/classroomUtils";

const UserIcon = FiUser;

const isNotAssignedLabel = (value) => {
  const normalized = String(value || "").trim().toLowerCase();
  return (
    !normalized ||
    normalized === "—" ||
    normalized === "nog niet ingedeeld" ||
    normalized === "not assigned" ||
    normalized === "unassigned"
  );
};

const getChildClassroomFallback = (child) => {
  const direct =
    child?.currentClassName ||
    child?.className ||
    child?.classroomName ||
    child?.currentClassroom?.className ||
    child?.currentClassroom?.classroomName ||
    child?.currentClassroom?.name ||
    child?.classroom?.className ||
    child?.classroom?.classroomName ||
    child?.classroom?.name ||
    "";

  if (direct) return direct;

  const childClassrooms = Array.isArray(child?.classrooms) ? child.classrooms : [];
  const current = childClassrooms.find((item) => item?.current || item?.isCurrent) || childClassrooms[0];
  return getClassroomName(current);
};

const ChildHeaderCard = ({
  t,
  child,
  classroomsByChild,
  pendingChildren = [],
  pendingChildUpdateSet = new Set(),
}) => {
  const childName = getChildName(child, t);
  const age = getChildAge(child);
  const birthDate = formatDate(getBirthDateValue(child));
  const classroomLabelFromState = getClassroomLabel(child, classroomsByChild, t);
  const fallbackClassroomLabel = getChildClassroomFallback(child);
  const classroomLabel = isNotAssignedLabel(classroomLabelFromState)
    ? fallbackClassroomLabel || classroomLabelFromState
    : classroomLabelFromState;

  const metaParts = [classroomLabel, age !== null ? `${age} jaar` : ""].filter(Boolean);
  const pendingMatch = Array.isArray(pendingChildren)
    ? pendingChildren.find(
        (pending) =>
          String(pending.entityId) === String(child?.id) ||
          String(pending.id) === String(child?.id),
      )
    : undefined;

  const hasPendingUpdate =
    pendingChildUpdateSet.has(String(child?.id)) ||
    Boolean(
      pendingMatch &&
        pendingMatch.action === "UPDATE" &&
        (pendingMatch.status === "PENDING" || pendingMatch.pending),
    );

  return (
    <div className="flex min-w-0 items-center gap-3 rounded-full bg-transparent py-1 pl-1 pr-0 text-left">
      <CircleIcon tone="pink">
        <UserIcon className="h-5 w-5" aria-hidden="true" />
      </CircleIcon>

      <div className="min-w-0">
        <p className="m-0 max-w-[12rem] truncate text-[0.98rem] font-black leading-tight text-slate-950 dark:text-slate-50">
          {childName}
        </p>

        <p className="mt-1 max-w-[12rem] truncate text-[0.78rem] font-bold leading-tight text-slate-500 dark:text-slate-400">
          {metaParts.length > 0 ? metaParts.join(" • ") : birthDate || "—"}
        </p>

        {hasPendingUpdate && (
          <span className="mt-1 inline-flex w-fit items-center rounded-full
                          bg-amber-100 px-2.5 py-0.5
                          text-[0.65rem] font-bold uppercase tracking-wide
                          text-amber-800 dark:bg-amber-950/60 dark:text-amber-200">
            In behandeling
          </span>
        )}
      </div>
    </div>
  );
};

export default ChildHeaderCard;
